function parse(value) {
    const text = String(value == null ? '' : value).replace(/[\s\u00a0\u202f]/g, '').replace(',', '.');
    if (!/^\d+(?:\.\d{1,2})?$/.test(text)) return null;
    const [whole, decimal = ''] = text.split('.');
    const amount = Number(whole) * 100 + Number(decimal.padEnd(2, '0'));
    return Number.isSafeInteger(amount) && amount >= 0 ? amount : null;
}
function money(value, currency = '') {
    return value == null ? '—' : `${(value / 100).toLocaleString('ru-RU', {minimumFractionDigits: 2, maximumFractionDigits: 2})}${currency ? ` ${currency}` : ''}`;
}
function difference(value, currency = '') {
    if (value == null) return '—';
    if (value === 0) return `${money(0, currency)} · Без разницы`;
    return `${value > 0 ? '+' : '−'}${money(Math.abs(value), currency)} · ${value > 0 ? 'Больше' : 'Меньше'} на ${money(Math.abs(value), currency)}`;
}
function input(value) {
    return value == null ? '' : `${Math.floor(value / 100)}.${String(value % 100).padStart(2, '0')}`;
}
export default {parse, money, difference, input};
